import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Generate a clean, SEO-friendly slug (German-friendly)
export function toSlug(input: string): string {
  let s = input.toLowerCase();
  // German character normalization
  s = s
    .replace(/ä/g, "ae")
    .replace(/ö/g, "oe")
    .replace(/ü/g, "ue")
    .replace(/ß/g, "ss");
  // Strip remaining diacritics
  s = s.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  // Replace & with 'und' for German
  s = s.replace(/&/g, "und");
  // Remove invalid characters
  s = s.replace(/[^a-z0-9\s-]/g, "");
  // Collapse whitespace to hyphens
  s = s.replace(/\s+/g, "-").replace(/-+/g, "-");
  // Trim hyphens
  s = s.replace(/^-+|-+$/g, "");
  return s;
}
